import React from "react";
import Hero from "./home/hero";
import About from "./home/About";
import Brokers from "./home/Brokers";
import InvestmentTiers from "./home/InvestmentTiers";
import Performance from "./home/performance";
import InvestmentSolutions from "./home/InvestmentSolutions";
import Pricing from "./home/Pricing";
import WhyChoose from "./home/WhyChoose";
import HomeVideo from "./home/HomeVideo";
import Testimonial from "./home/Testimonials";
import Counters from "./home/Counters";
import PremiumInvestmentSolutions from "./home/PremiumInvestmentSolutions";
import PerformanceCard from "./home/PerformanceCard";

function Home() {
  return (
    <main>
      {/* Hero Section */}
      <Hero />
      {/* About Section */}
      <About />
      {/* Brokers Section */}
      <Brokers />
      {/* Investment Tiers */}
      <InvestmentTiers />
      {/* Performance Section */}
      <Performance />
      {/* Performance Card */}
      <PerformanceCard />
      {/* InvestmentSolutions  */}
      <InvestmentSolutions />
      {/* Pricing Section */}
      <Pricing />
      {/* Why Choose Us */}
      <WhyChoose />
      {/* Home Video */}
      <HomeVideo />
      {/*Testimonials Section*/}
      <Testimonial />
      {/*Counters Section*/}
      <Counters />
      {/*Premium Investment Solutions Section*/}
      <PremiumInvestmentSolutions />
    </main>
  );
}

export default Home;
